import { query, collection, onSnapshot, orderBy} from 'firebase/firestore';
import db from '../backend/DBFiresbase';

const getDataCollectionProveedores = ( estado ) => {

    onSnapshot(query(collection(db,"proveedores"), orderBy("razonSocial", "asc")), (querySnapshot) => {
        const docs = [];

        querySnapshot.forEach((doc) => {
            docs.push({...doc.data(), id:doc.id});
        });
        estado(docs);
    });
}

export default getDataCollectionProveedores;